import { Suspense, lazy, useEffect } from 'react';

import { Hero } from './Hero';
import { PLACEHOLDER_NOTICE } from './media';
import { Navbar } from './Navbar';
import { ProductJourney } from './ProductJourney';

/** Sections 4–10 ship in their own chunk; the hero never waits on them. */
const BelowFold = lazy(() => import('./BelowFold'));

const TITLE = 'Vaanexa — Turn every conversation into business';
const DESCRIPTION =
  'Vaanexa connects WhatsApp and Instagram with AI-powered conversations, lead management, follow-ups, bookings, quotations, payments and analytics — all from one intelligent platform.';

/** Keeps the document title and description in step with this route. */
function useDocumentMeta(): void {
  useEffect(() => {
    document.title = TITLE;
    let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'description';
      document.head.appendChild(tag);
    }
    tag.content = DESCRIPTION;
  }, []);
}

export function MarketingHome(): JSX.Element {
  useDocumentMeta();

  // Loud reminder while the video URLs are still third-party sample clips.
  useEffect(() => {
    if (PLACEHOLDER_NOTICE) {
      console.warn(
        '[vaanexa] Marketing video URLs are PLACEHOLDERS from a public sample bucket. ' +
          'Replace them in src/marketing/media.ts before production.',
      );
    }
  }, []);

  return (
    <div className="mk mk-page-root min-h-dvh">
      <a
        href="#mk-main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-[var(--mk-surface-strong)] focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-[var(--mk-ink)]"
      >
        Skip to content
      </a>

      <Navbar />

      <main id="mk-main">
        <Hero />
        <ProductJourney />
        {/* The reserved height keeps the scrollbar stable while the chunk loads. */}
        <Suspense fallback={<div style={{ minHeight: '100vh' }} aria-hidden />}>
          <BelowFold />
        </Suspense>
      </main>
    </div>
  );
}
